"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createElement = void 0;
var react_dom_1 = require("react-dom");
function createElement(jsx) {
    var element = document.createElement("div");
    element.style.padding = "1em";
    (0, react_dom_1.render)(jsx, element);
    return element;
}
exports.createElement = createElement;
//# sourceMappingURL=dom.js.map